// currency input directive
import { Directive } from '@angular/core';

@Directive({
  selector: '[onlyNumber]',
  host: {
    '(keydown)': 'validateNumber($event)',
  },
})
export class OnlyNumberDirective {
  constructor() {}
  // array of valids keys  for currency input
  private validKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Del',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
  ];

  validateNumber(event: KeyboardEvent) {
    if (!this.validKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
